// Self-hosted fonts (CSP font-src 'self'): Hind Siliguri for text, Anek Bangla for headings.
import '@fontsource/hind-siliguri/400.css';
import '@fontsource/hind-siliguri/500.css';
import '@fontsource/hind-siliguri/600.css';
import '@fontsource/hind-siliguri/700.css';
import '@fontsource-variable/anek-bangla/wght.css';
import './styles/globals.css';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { TooltipProvider } from './components/ui/tooltip';
import { Toaster } from './components/ui/sonner';
import { setUnauthorizedHandler } from './lib/api';
import { AuthProvider } from './components/auth-provider';
import { createQueryClient } from './lib/query-client';
import { loadSession, sessionExpired } from './lib/session';
import { createAppRouter } from './router';

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root element');

// The session is resolved before the first render, so route guards see the real user.
const user = await loadSession();
const queryClient = createQueryClient();
const router = createAppRouter(queryClient, user);

// 401 from the API mid-session → /login with "session expired", back here after sign-in.
setUnauthorizedHandler(() => {
  if (router.state.location.pathname === '/login') return;
  sessionExpired(router.state.location.href);
});

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider user={user}>
        <TooltipProvider delayDuration={300}>
          <RouterProvider router={router} />
          <Toaster />
        </TooltipProvider>
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
